<template>
  <div :class="['module']">
    <div class="wrap">
      <h3>{{ headline }}</h3>
      <form>
        <slot></slot>
      </form>
    </div>
  </div>
</template>

<script>

  export default {
    name: 'QuestionGroup',
    props: {
      headline: {
        type: String,
        required: true
      }
    },
    data () {
      return {}
    }
  }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

  @import "~globals";

  h3 {
    @include font-size(xxlarge, $headline: true);
    @include media(small) {
      font-size:4.25rem;
    }
    margin-bottom:3rem;
  }

</style>



// WEBPACK FOOTER //
// src/components/_global/question-group.vue